import { FlexCol } from "src/componentes";
import { SectionRating } from "./Rating/SectionRating";
import { SectionBanner } from "./SectionBanner";
import { SectionDoubts } from "./SectionDoubts";
import { SectionOurNumber } from "./SectionOurNumber";
import { SectionOurServices } from "./SectionOurServices";
import { SectionPartners } from "./SectionPartners";
import { SectionSecond } from "./SectionSecond";

export const Home = () => {
  return (
    <FlexCol className="m-0 gap-0">
      <SectionBanner id="#" />
      <SectionOurServices id="servicos" />
      <SectionDoubts id="perguntas" />
      <SectionOurNumber />
      <SectionPartners />
      <SectionSecond />
      <SectionRating />
    </FlexCol>
  );
};
